<!--
  @description v2.0.2 网上事故录入-详情页
  @author xiehan
  @date 2019/02/14
-->
<template>
  <div>
    <g-back :history="history"></g-back>
    <div style="width: 600px;">
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.title')" class="accident-title"></span>：
          <span v-text="accidentInfo.title"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.entryUser')" class="accident-title"></span>：
          <span v-text="accidentInfo.creator"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.startTime')" class="accident-title"></span>：
          <span v-text="accidentInfo.startTime"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.findTime')" class="accident-title"></span>：
          <span v-text="accidentInfo.findTime"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.endTime')" class="accident-title"></span>：
          <span v-text="accidentInfo.endTime"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.createTime')" class="accident-title"></span>：
          <span v-text="accidentInfo.createTime"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.effect')" class="accident-title"></span>：
          <span v-text="accidentInfo.effect"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.effectLevel')" class="accident-title"></span>：
          <span v-text="select_level[accidentInfo.effectLevel]"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.status')" class="accident-title"></span>：
          <span v-text="select_status[accidentInfo.status]"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.reason')" class="accident-title"></span>：
          <span v-text="select_reason[accidentInfo.reason]"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <span v-text="$t('accidentEntry.group')" class="accident-title"></span>：
          <span v-text="select_group[accidentInfo.group]"></span>
        </el-col>
        <el-col :span="12">
          <span v-text="$t('accidentEntry.problemSource')" class="accident-title"></span>：
          <span v-text="select_source[accidentInfo.problemSource]"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <span v-text="$t('accidentEntry.detail')" class="accident-title"></span>：
          <span v-text="accidentInfo.detail"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <span v-text="$t('accidentEntry.reasonAnalysis')" class="accident-title"></span>：
          <span v-text="accidentInfo.reasonAnalysis"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <span v-text="$t('accidentEntry.solution')" class="accident-title"></span>：
          <span v-text="accidentInfo.solution"></span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <span v-text="$t('accidentEntry.correctAction')" class="accident-title"></span>：
          <span v-text="accidentInfo.correctAction"></span>
        </el-col>
      </el-row>
      <div v-text="$t('accidentEntry.historyRecord')" v-if="accidentInfo.records"></div>
      <div v-if="accidentInfo.records" v-for="(item, index) in accidentInfo.records" :key="item.operateTime + index">
        <div v-if="!item.oriValue">
          <span v-text="item.operateTime"></span>
          <span v-text="item.operator"></span>
          <span v-text="$t('accidentEntry.amend')"></span>
          <span v-text="item.propertyName"></span>
        </div>
        <div v-else>
          <span v-text="item.operateTime"></span>
          <span v-text="item.operator"></span>
          <span v-text="$t('accidentEntry.make')"></span>
          <span v-text="item.propertyName"></span>
          <span v-text="$t('accidentEntry.from')"></span>
          <span v-text="item.oriValue"></span>
          <span v-text="$t('accidentEntry.change')"></span>
          <span v-text="item.updatedValue"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        history: [],
        select_group: {},
        select_reason: {},
        select_status: {},
        select_level: {},
        select_source: {},
        accidentInfo: {}
      }
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('accidentType'),
          this.dGetDictionaryByCode('accidentStatus'),
          this.dGetDictionaryByCode('effectLevel'),
          this.dGetDictionaryByCode('problemSource')
        ])
        this.select_group = { ...this.dDictionary.groupType }
        this.select_reason = { ...this.dDictionary.accidentType }
        this.select_status = { ...this.dDictionary.accidentStatus }
        this.select_level = { ...this.dDictionary.effectLevel }
        this.select_source = { ...this.dDictionary.problemSource }
        this.init()
      },
      setHistory (name) {
        this.history = []
        this.history.push({ name: name })
      },
      init () {
        systemSettingBiz.getAccidentById({ id: this.$route.query.id }).then((res) => {
          this.setHistory(res.title)
          this.accidentInfo = res
          this.accidentInfo.startTime = TimeFormat.getFormatTime(this.accidentInfo.startTime)
          this.accidentInfo.findTime = TimeFormat.getFormatTime(this.accidentInfo.findTime)
          this.accidentInfo.endTime = TimeFormat.getFormatTime(this.accidentInfo.endTime)
          this.accidentInfo.createTime = TimeFormat.getFormatTime(this.accidentInfo.createTime)
          if (this.accidentInfo.records) {
            this.accidentInfo.records.map((item) => {
              item.operateTime = TimeFormat.getFormatTime(item.operateTime)
              switch (item.propertyName) {
                case this.$t('accidentEntry.status'):
                  item.oriValue = this.select_status[item.oriValue]
                  item.updatedValue = this.select_status[item.updatedValue]
                  break
                case this.$t('accidentEntry.effectLevel'):
                  item.oriValue = this.select_level[item.oriValue]
                  item.updatedValue = this.select_level[item.updatedValue]
                  break
                case this.$t('accidentEntry.group'):
                  item.oriValue = this.select_group[item.oriValue]
                  item.updatedValue = this.select_group[item.updatedValue]
                  break
                case this.$t('accidentEntry.reason'):
                  item.oriValue = this.select_reason[item.oriValue]
                  item.updatedValue = this.select_reason[item.updatedValue]
                  break
                case this.$t('accidentEntry.problemSource'):
                  item.oriValue = this.select_source[item.oriValue]
                  item.updatedValue = this.select_source[item.updatedValue]
                  break
                default:
              }
            })
          }
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'accidentDetail' && from.name === 'accidentEntry') {
          this.getDic()
        }
      }
    },
    mounted () {
      this.getDic()
    }
  }
</script>

<style scoped>
  .accident-title {
    display: inline-block;
    width: 60px;
    text-align: right;
  }
</style>